













import { Vue, Component, Prop } from "vue-property-decorator";
import { Family } from "../../models";

@Component({})
export default class CompanyFamilyItem extends Vue {
  @Prop({ required: true })
  readonly family!: Family;
}
